import React, { useState, useEffect, useCallback, useMemo } from 'react'
import LabelCardHome from './LabelCardHome'
import { ReactComponent as IconCow } from '../../../../../assets/trace.svg' // SVG'yi React bileşeni olarak içe aktarma
import { ReactComponent as IconCowWhite } from '../../../../../assets/tracewhite.svg' // SVG'yi React bileşeni olarak içe aktarma
import useOrderStore from 'store/client/orderStore'
import { BASE_URL2 } from 'config/axios'
import { use } from 'react'

export default function MultiFabricLabelsHome({ data: { washingLabel,washingAdditionalPhrases, country, sizeGroup},SizeData,isHursan,isZorlu }) {
  const { referance } = useOrderStore()
  const [isLeatherType, setIsLeatherType] = useState(false)
  const [currentNumber, setCurrentNumber] = useState(2)
  const [cards, setCards] = useState([])
  const symbol = washingLabel[0]?.symbol
  const [firstcard, setFirstcard] = useState(null)
  const [filteredWashingAdditionalPhrases, setFilteredWashingAdditionalPhrases] = useState(washingAdditionalPhrases)
  const [totalWidth, setTotalWidth] = useState(0)
  const leatherTypes = [
    "BUFFALO FURSKIN", "BUFFALO LEATHER", "CALF FURSKIN", "COLT LEATHER",
    "COW FURSKIN", "GOAT LEATHER", "HORSE LEATHER", "LAMB FURSKIN",
    "LAMBSKIN", "PIG FURSKIN", "PIG LEATHER", "RABBIT LEATHER",
    "SHEEP FURSKIN", "SHEEP LEATHER"
  ]

  useEffect(() => {
    const filtered = (sizeGroup.variant === 'rug' && SizeData) 
      ? washingAdditionalPhrases.slice(1) 
      : washingAdditionalPhrases;
    setFilteredWashingAdditionalPhrases(filtered);
  }, [sizeGroup.variant, SizeData, washingAdditionalPhrases]);

  useEffect(() => {
    // sizeGroup variant değişikliği için gerekli işlemler
  }, [filteredWashingAdditionalPhrases,sizeGroup.variant, SizeData]);
  

  const isBlackLabel = referance?.backgroundColor === 'B'

  const getType = useCallback((number) => (number % 2 === 0 ? 'back' : 'front'), [])

  // washingLabel değerlerini memoize edelim
  const fabricData = useMemo(() => washingLabel?.[0]?.fabric || [], [washingLabel])
  const symbolData = useMemo(() => washingLabel?.[0]?.symbol || {}, [washingLabel])

  const renderCountryCard = useCallback((translations, number) => {
    const text = translations.map(translate => translate.translation).join(' / ');
    const localCards = [];
    let currentCardContents = [];
    let currentCardLength = 0;
    let currentNumber = number;
    let content1=""
    let content2=""
    let content3=""
    let content4=""
    let calculatedTotalWidth = 0; // Local değişken olarak hesapla

if(fabricData.length < 2 && fabricData[0]?.mix.length < 2){
  content1=fabricData[0].mix[0]?.percent
  content2=fabricData[0].mix[0]?.text
  calculatedTotalWidth = content2.length
  setTotalWidth(calculatedTotalWidth)
}
if(fabricData.length < 2 && fabricData[0]?.mix.length === 2){
  content1=fabricData[0].mix[0]?.percent
  content2=fabricData[0].mix[0]?.text
  content3=fabricData[0].mix[1]?.percent
  content4=fabricData[0].mix[1]?.text
  calculatedTotalWidth = content2.length + content4.length
  setTotalWidth(calculatedTotalWidth)
}
console.log("currentCardContents",fabricData);
 
    const addCard = () => {
      if (currentCardContents.length > 0) {
        localCards.push(
          isHursan ?           <LabelCardHome
          key={currentNumber}
          type='front'
          number={currentNumber}
          isHursan={isHursan}
          isZorlu={isZorlu}
        >
          <div style={{justifyContent:"center",marginTop:-2,marginLeft:-56}} className="flex flex-col items-center h-full" >
          <p
className="text-[6pt] leading-[5.3pt] text-justify arial-regular"
style={{
  maxWidth: '79.2mm',
  fontWeight: '400',
  margin: 0,
  padding: 0,
  lineHeight:"9px",
  wordSpacing: -0.2,        // Illustrator’da ekstra word-spacing yok
  letterSpacing: '-0.45px',   // VA -12’ye denk geliyor
  whiteSpace: 'normal',
  marginLeft:-2,

}}
>
{currentCardContents.map((item, index) => (
  <span key={index} >
    {item}
    {index < currentCardContents.length - 1 && '/'}
  </span>
))}
</p>


            {sizeGroup.variant !== 'rug'&&fabricData.length < 2 && fabricData[0]?.mix.length < 2 && (() => {
              const localTotalWidth = fabricData[0]?.mix[0]?.text?.length || 0;
              return localTotalWidth < 362;
            })() &&(
              <div style={{marginTop:-4,width:"100%",display:"flex",flexDirection:"row",alignItems:"flex-start",paddingLeft:88}}>
              <div  >
              <span
className="narrowbold"
style={{
  fontSize: "9.5pt",
  marginRight: 4,
  marginLeft:-7.4,

  marginTop:-0.6
}}
>
{content1 + '%'}
</span>
                           </div>
              <div   className="text-[7.7pt] leading-[5.8pt] text-justify"
style={{
  maxWidth: '69mm', // yaklaşık 567pt (uyumlu ölçü)
  fontFamily: 'arialnarrow',
  fontWeight: '400',
  letterSpacing: "-0.3px", 
  lineHeight:"8px",
  wordSpacing: "-1.25px",
  paddingTop:4,


}}
>{content2}</div>
              </div>
            )}
            {sizeGroup.variant !== 'rug'&&fabricData.length < 2 && fabricData[0]?.mix.length === 2 && (() => {
      let localTotalWidth = (fabricData[0]?.mix || [])
      .reduce((sum, m) => sum + (m?.text?.length || 0), 0);

              return localTotalWidth < 275;
            })() && (
              <>
              <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"flex-start",paddingLeft:88}}>
              <div className={`${content1.length <= 3 && 'w-[20px]'}`}>
              <span
className="narrowbold"
style={{
  fontSize: "9.5pt",
  marginRight: 4,
  marginLeft:-7.4,
  marginTop:-0.6
}}
>
{content1 + '%'}
</span>
                           </div>
              <div   className="text-[7.7pt] leading-[6pt] text-justify"
style={{
  maxWidth: '83.15mm', // yaklaşık 567pt (uyumlu ölçü)
  fontFamily: 'arialnarrow',
  fontWeight: '400',
  letterSpacing: "-0.3px", 
  wordSpacing: "-1.25px",
  paddingTop:4,
  lineHeight:"10px",

}}
>{content2}</div>
              </div>

              <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"flex-start",paddingLeft:88,marginTop:-2}}>
              <div className={`${content3.length <= 3 && 'w-[20px]'}`}>
              <span
className="narrowbold"
style={{
  fontSize: "9.5pt",
  marginRight: 4,
  marginLeft:-7.4,
  marginTop:-0.6
}}
>
{content3 + '%'}
</span>
                           </div>
              <div   className="text-[7.7pt] leading-[6pt] text-justify"
style={{
  maxWidth: '83.15mm', // yaklaşık 567pt (uyumlu ölçü)
  fontFamily: 'arialnarrow',
  fontWeight: '400',
  letterSpacing: "-0.3px", 
  wordSpacing: "-1.25px",
  paddingTop:4,


}}
>{content4}</div>
              </div> 
              </>
            )}

            <div className="flex items-center h-full" style={{position:"absolute", top:6, right:17, transform: "rotate(-90deg) "}}>
            <div className="flex items-center h-full ">
         <div className="flex items-start justify-between px-[6mm] w-full" >
         <div
className="w-[21.3mm] h-[13mm] grid grid-cols-5 grid-rows-3 place-items-center items-start gap-x-0 gap-y-[-1px]"

>
{/* Üst sıra */}
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}.svg`}
  alt="sembol icon"
  style={{ width: 13, height: 14, padding: 0.4 ,marginLeft:9.4,marginTop:-0.6}}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}.svg`}
  alt="sembol icon"
  style={{ width: 15, height: 15, padding: 0.4,marginTop:-4.4,marginLeft:9.9 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}.svg`}
  alt="sembol icon"
  style={{ width: 12, height: 13, padding: 0.4,marginLeft:12.2,marginTop:-2.2}}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}.svg`}
  alt="sembol icon"
  style={{ width: 15.5, height: 13, padding: 0.4,marginTop:-0.5,marginLeft:13.5 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}.svg`}
  alt="sembol icon"
  style={{ width: 12, height: 12, padding: 0.4 ,marginLeft:15.7,marginTop:0.6}}
/>

{/* Orta sıra */}
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_1.svg`}
  alt="sembol icon"
  style={{  width: 14.2, height: 14.4, padding: 0.4 ,marginLeft:9,marginTop:-2.1 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_1.svg`}
  alt="sembol icon"
  style={{ width: 15, height: 15, padding: 0.4 ,marginLeft:10.7,marginTop:-3 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_1.svg`}
  alt="sembol icon"
  style={{  width: 13, height: 12, padding: 0.4 ,marginLeft:12.4,marginTop:0}}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_1.svg`}
  alt="sembol icon"
  style={{  width: 12.3, height: 12.3, padding: 0.4 ,marginLeft:14.5,marginTop:-1.7 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_1.svg`}
  alt="sembol icon"
  style={{ width: 15, height: 15, padding: 0.4 ,marginLeft:15.7,marginTop:-1.3 }}
/>

{/* Alt sıra */}
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_2.svg`}
  alt="sembol icon"
  style={{ width: 12, height: 13, padding: 0.4 ,marginLeft:9,marginTop:-0.9 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_2.svg`}
  alt="sembol icon"
  style={{ width: 12.5, height: 13.5, padding: 0.4 ,marginLeft:11,marginTop:-0.5 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_2.svg`}
  alt="sembol icon"
  style={{ width: 14, height: 13.4, padding: 0.4 ,marginLeft:12.6,marginTop:-1.5 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_2.svg`}
  alt="sembol icon"
  style={{ width: 15.9, height: 14.2, padding: 0.4 ,marginLeft:15,marginTop:-0.6 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_2.svg`}
  alt="sembol icon"
  style={{ width: 12, height: 12, padding: 0.4 ,marginLeft:15,marginTop:-1.3 }}
/>
</div>

      
        </div>
      </div>
        </div>
          </div>
        </LabelCardHome>: 
          
          
          <LabelCardHome
          key={currentNumber}
          type={currentNumber % 2 === 0 ? 'back' : 'front'}
          number={currentNumber}
          isHursan={isHursan}
          isZorlu={isZorlu}
        >
          <div style={{justifyContent:"center",paddingRight:"16mm",marginTop:0,marginRight:-12}} className="flex flex-col items-center h-full" >
          <p
className="text-[7.7pt] leading-[6.7pt] text-justify arialnarrow"
style={{
  maxWidth:isZorlu ? '83.15mm' : '91.2mm',
  fontWeight: '400',
  margin: 0,
  padding: 0,
  wordSpacing: -0.2,        // Illustrator’da ekstra word-spacing yok
  letterSpacing: '-0.45px',   // VA -12’ye denk geliyor
  whiteSpace: 'normal',
  marginLeft:-2,

}}
>
{currentCardContents.map((item, index) => (
  <span key={index} >
    {item}
    {index < currentCardContents.length - 1 && '/'}
  </span>
))}
</p>


            {sizeGroup.variant !== 'rug'&&fabricData.length < 2 && fabricData[0]?.mix.length < 2 && (() => {
              const localTotalWidth = fabricData[0]?.mix[0]?.text?.length || 0;
              return localTotalWidth < 362;
            })() &&  (
              <div style={{marginBottom:4,width:"100%",display:"flex",flexDirection:"row",alignItems:"flex-start",paddingLeft:isZorlu ? 28 : 12,marginTop:1}}>
              <div  >
              <span
className="narrowbold"
style={{
  fontSize: "9.5pt",
  marginRight: 4,
  marginLeft:-7.4,

  marginTop:-0.6
}}
>
{content1 + '%'}
</span>
                           </div>
              <div   className="text-[7.7pt] leading-[7.1pt] text-justify"
style={{
  maxWidth: isZorlu ? '74.8mm' : '83.15mm', // yaklaşık 567pt (uyumlu ölçü)
  fontFamily: 'arialnarrow',
  fontWeight: '400',
  letterSpacing: "-0.3px", 
  lineHeight:"10px",
  wordSpacing: "-1.25px",
  paddingTop:4,


}}
>{content2}</div>
              </div>
            )}
            {sizeGroup.variant !== 'rug'&&fabricData.length < 2 && fabricData[0]?.mix.length === 2 && (() => {
              const localTotalWidth = (fabricData[0]?.mix[0]?.text?.length || 0) + (fabricData[0]?.mix[1]?.text?.length || 0);
              return localTotalWidth < 362;
            })() && (
              <>
                <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"flex-start",paddingLeft:isZorlu ? 28 : 12}}>
              <div className={`${content1.length <= 3 && 'w-[20px]'}`}>
              <span
className="narrowbold"
style={{
  fontSize: "9.5pt",
  marginRight: 4,
  marginLeft:-7.4,
  marginTop:-0.6
}}
>
{content1 + '%'}
</span>
                           </div>
              <div   className="text-[7.7pt] leading-[6pt] text-justify"
style={{
  maxWidth: isZorlu ? '74.8mm' : '83.15mm', // yaklaşık 567pt (uyumlu ölçü)
  fontFamily: 'arialnarrow',
  fontWeight: '400',
  letterSpacing: "-0.3px", 
  wordSpacing: "-1.25px",
  paddingTop:4,
  lineHeight:"10px",

}}
>{content2}</div>
              </div>

              <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"flex-start",paddingLeft:12,marginTop:-2}}>
              <div className={`${content3.length <= 3 && 'w-[20px]'}`}>
              <span
className="narrowbold"
style={{
  fontSize: "9.5pt",
  marginRight: 4,
  marginLeft:-7.4,
  marginTop:-0.6
}}
>
{content3 + '%'}
</span>
                           </div>
              <div   className="text-[7.7pt] leading-[6pt] text-justify"
style={{
  maxWidth: '83.15mm', // yaklaşık 567pt (uyumlu ölçü)
  fontFamily: 'arialnarrow',
  fontWeight: '400',
  letterSpacing: "-0.3px", 
  wordSpacing: "-1.25px",
  paddingTop:4,


}}
>{content4}</div>
              </div> 
              </>
            )}
            {sizeGroup.variant === 'rug' && SizeData && (
              <>
        
              {filteredWashingAdditionalPhrases.length > 0 && (
      <>
        {filteredWashingAdditionalPhrases.map((translation, index) => {
          let number = currentNumber++
          return (
            <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"flex-start",paddingLeft:isZorlu ? 28 : 12}}>
          
            <div   className="text-[5.9pt] leading-[6pt] text-justify"
style={{
  maxWidth: isZorlu ? '74.8mm' : '83.15mm', // yaklaşık 567pt (uyumlu ölçü)
  fontFamily: 'arialnarrow',
  fontWeight: '400',
  letterSpacing: "-0.3px", 
  wordSpacing: "-1.25px",
  paddingTop:3,


}}
>{translation.text}</div>
              </div> 
          )
        })}
      </>
    )}
              </>
              
            )}
            <div className="flex items-center h-full" style={{position:"absolute", top:6, right:isZorlu ? 6 : -38, transform: "rotate(-90deg) "}}>
            <div className="flex items-center h-full ">
         <div className="flex items-start justify-between px-[6mm] w-full" >
         <div
className="w-[21.3mm] h-[14mm] grid grid-cols-5 grid-rows-3 place-items-center items-start gap-x-0 gap-y-[-1px]"

>
{/* Üst sıra */}
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}.svg`}
  alt="sembol icon"
  style={{ width: 13, height: 14, padding: 0.4 ,marginLeft:1.4,marginTop:-0.6}}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}.svg`}
  alt="sembol icon"
  style={{ width: 14, height: 15, padding: 0.4,marginTop:-1.4,marginLeft:3.9 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}.svg`}
  alt="sembol icon"
  style={{ width: 11, height: 11, padding: 0.4,marginLeft:8.2,marginTop:1.8 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}.svg`}
  alt="sembol icon"
  style={{ width: 14.5, height: 13, padding: 0.4,marginTop:0.5,marginLeft:11.5 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}.svg`}
  alt="sembol icon"
  style={{ width: 12, height: 12, padding: 0.4 ,marginLeft:15.7,marginTop:0.6}}
/>

{/* Orta sıra */}
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_1.svg`}
  alt="sembol icon"
  style={{  width: 12.7, height: 12.5, padding: 0.4 ,marginLeft:2,marginTop:-2.1 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_1.svg`}
  alt="sembol icon"
  style={{ width: 14, height: 14, padding: 0.4 ,marginLeft:3.7,marginTop:-3 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_1.svg`}
  alt="sembol icon"
  style={{  width: 13, height: 12, padding: 0.4 ,marginLeft:8.4,marginTop:-2}}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_1.svg`}
  alt="sembol icon"
  style={{  width: 12.3, height: 12.3, padding: 0.4 ,marginLeft:11.5,marginTop:-1.7 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_1.svg`}
  alt="sembol icon"
  style={{ width: 13, height: 13, padding: 0.4 ,marginLeft:15.7,marginTop:-2.4 }}
/>

{/* Alt sıra */}
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_2.svg`}
  alt="sembol icon"
  style={{ width: 12, height: 13, padding: 0.4 ,marginLeft:2,marginTop:-2.9 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_2.svg`}
  alt="sembol icon"
  style={{ width: 13.5, height: 13.5, padding: 0.4 ,marginLeft:5,marginTop:-5.5 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_2.svg`}
  alt="sembol icon"
  style={{ width: 13, height: 13.4, padding: 0.4 ,marginLeft:8.6,marginTop:-4.5 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_2.svg`}
  alt="sembol icon"
  style={{ width: 14.9, height: 14.2, padding: 0.4 ,marginLeft:12,marginTop:-5.6 }}
/>
<img
  src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_2.svg`}
  alt="sembol icon"
  style={{ width: 12, height: 12, padding: 0.4 ,marginLeft:15,marginTop:-2.3 }}
/>
</div>

      
        </div>
      </div>
        </div>
          </div>
        </LabelCardHome>
        );
        currentNumber++;
      }
      currentCardContents = [];
      currentCardLength = 0;
    };
  
    // Metni kelimelere böl
    const words = text.split(' ');
    let currentText = '';
  
    words.forEach(word => {
      if ((currentText + ' ' + word).length <= 350) {
        currentText += (currentText ? ' ' : '') + word;
      } else {
        currentCardContents.push(currentText);
        currentCardLength += currentText.length;
        if (currentCardLength >= 350) {
          addCard();
        }
        currentText = word;
      }
    });
  
    if (currentText) {
      currentCardContents.push(currentText);
    }
  
    if (currentCardContents.length > 0) {
      addCard();
    }
  
    return { cards: localCards, lastNumber: currentNumber };
  }, [firstcard, symbol, isBlackLabel, sizeGroup, SizeData, filteredWashingAdditionalPhrases])


  const renderLabelCards = useCallback((fabricArray, localCurrentNumber) => {
    let totalTextLength = 0;
    const allContents = [];
    let totalwidth=0;
    
 
if (fabricData.length < 2) {
  for (let i = 0; i < fabricData.length; i++) {
    let mixes = fabricData[i].mix;

    for (let j = 0; j < mixes.length; j++) {
      let text = mixes[j]?.text || "";
      totalwidth += text.length;
    }
  }
}


    if(fabricData.length < 2 && fabricData[0]?.mix.length === 2 ){
      let content1=fabricData[0].mix[0]?.text
      let content4=fabricData[0].mix[1]?.text
        totalwidth=content1.length+content4.length
      }
      console.log("totalwidth",totalwidth)

    if (fabricData.length < 2 && fabricData[0]?.mix.length < 2 &&totalwidth < 362) {
      return { cards: [], lastNumber: localCurrentNumber }
    }

    if(fabricData.length < 2 && fabricData[0]?.mix.length === 2&&totalwidth < 275){
 
      return { cards: [], lastNumber: localCurrentNumber }
      }

    // Tüm item'ları sırayla tek listede topla
    fabricArray.forEach(item => {
      if (item.text) {
        allContents.push({ type: "text", content: item.text });
        totalTextLength += item.text.length;
      }
      item.mix?.forEach(mix => {
        if (mix?.text && mix?.percent) {
          const mixText = `${mix.percent}% ${mix.text}`.replace(/-/g, '/');
          allContents.push({ type: "mix", content: mixText });
          totalTextLength += mix.text.length;
        }
      });
    });
    const fixedPaddingTopBottom = 12; // toplam 4px üst + 4px alt
    const usableHeightPt = 25 * 2.835 - fixedPaddingTopBottom; // mm → pt (1mm ≈ 2.835pt)

    // Stil hesaplama
  let scaleY = 1.04;
  let fontPt = 6;
  let linePt = 6;
  let paddingTop = 2;    // DEFAULT: 2px
  let marginBottom = 2;  // DEFAULT: 2px
  let lineHeight = "normal";
  let marginTop=0;
  const estimatedLineCount = Math.ceil(totalTextLength / 50);
  const estimatedHeight = estimatedLineCount * (linePt + 1);

  if (estimatedHeight > 22) {
    paddingTop = 1;     // biraz daha sıkıştır
    marginBottom = 1;
    lineHeight = "1";
    marginTop=-3;
  }
  if (estimatedHeight > 24) {
    paddingTop = 1;
    marginBottom = 1;
    lineHeight = "1.2";
    scaleY = 0.92;
    fontPt = 5.1;
    linePt = 5.1;
    marginTop=-3;

  }
  if (estimatedHeight > usableHeightPt) {
    // Çok uzun: fontu ve ölçeği küçült
    fontPt = 5.1;
    linePt = 5.1;
    scaleY = 0.92;
    paddingTop = 1;
    marginBottom = 1;
    marginTop=-3;

  }

    const localCards = [];
    let currentCardContents = [];
    let currentCardLength = 0;
    let number = localCurrentNumber;
    let processedContents = 0; // İşlenen içerik sayısını takip et
  
    const addCard = () => {
      if (currentCardContents.length === 0) return;
  
      const isLastCard = processedContents + currentCardContents.length >= allContents.length; // Son kart kontrolü
  
      localCards.push(
        <LabelCardHome
          key={number}
          className="font-arialMs text-[5.7pt] leading-[5.7pt] px-[2.5mm]"
          number={number}
          type={getType(number)}
          isHursan={isHursan}
          isZorlu={isZorlu}
        >
          <div className="flex flex-col items-start justify-center h-full w-full"
               style={{
                 paddingLeft: "2.5mm", paddingRight: "12mm",
                 width: "120mm", height: "25mm", marginLeft: "0"
               }}>
         {currentCardContents.map((content, index) => {
  const [percent, text] = content.split('%');
  const isFabric = percent.length > 3;
  const LeatherIcon = isBlackLabel ? IconCowWhite : IconCow;

  const isLast = index === currentCardContents.length - 1;

  return (
    <div
      key={index}
      className="flex items-center gap-x-[2px] text-justify"
      style={{
        paddingTop: index === 0 ? '0px' : `${paddingTop}px`,
        transform: `scaleY(${scaleY})`,
        paddingRight:'5mm'
        
      }}
    >
      <div
        className="flex flex-col"
        style={{ marginBottom: isLast ? '0px' : `${marginBottom}px` }} // ✅ Sadece son satırda marginBottom = 0
      >
        <div className={`${percent.length <= 3 ? 'w-[20px]' : ''}`}>
        <span
  className="arial-narrow"
  style={{
    fontSize: `${fontPt + 1.5}pt`,
    marginRight: 5,
    lineHeight: lineHeight,
    marginTop: marginTop,
  }}
>
  {isFabric ? (
    percent
  ) : (
    <>
      <span className="narrowbold">{percent}</span>
      <span className="narrowbold">%</span>
    </>
  )}
</span>

        </div>

        {isLeatherType && number === 6 && (
          <LeatherIcon
            style={{
              width: '4.968mm',
              height: '4.468mm',
              marginTop: '2px',
            }}
            preserveAspectRatio="none"
          />
        )}
      </div>

      <div
        className={`text-[${fontPt}pt] leading-[${linePt}pt] text-justify`}
        style={{
          fontFamily: 'Arial, sans-serif',
          fontWeight: '400',
          marginTop:marginTop+6
        }}
      >
        {text}
      </div>
    </div>
  );
})}

         {sizeGroup.variant === 'rug' && SizeData && isLastCard && (
           <div style={{  left: 60, bottom: 5, minWidth: 200, textAlign: "left", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
             <p className="arial-bold"
               style={{
                 fontSize: "16.5px",
                 lineHeight: "19.7px",
                 letterSpacing: "0px",
                 color: "black",
               }}
             >{SizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
             <p className="arial-bold"
               style={{
                 fontSize: "16.5px",
                 lineHeight: "19.7px",
                 letterSpacing: "0px",
                 color: "black",
                 marginLeft: "6px"
               }}
             >{SizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
           </div>
         )}

          </div>
        </LabelCardHome>
      );
      processedContents += currentCardContents.length; // İşlenen içeriği güncelle
      number++;
      currentCardContents = [];
      currentCardLength = 0;
    };
  
    // Kartlara böl
    allContents.forEach(({ content }) => {
      const length = content.length;
      if (currentCardLength + length > 720) {
        addCard();
      }
      currentCardContents.push(content);
      currentCardLength += length;
    });
  
    addCard();
  
    return { cards: localCards, lastNumber: number };
  }, [getType, isBlackLabel, isLeatherType, sizeGroup, SizeData])
  

  // Leather type kontrolünü ayrı useEffect'e taşıyalım
  useEffect(() => {
    if (!fabricData.length) {
      setIsLeatherType(false)
      return
    }
    const containsLeather = fabricData.some(item =>
      item?.mix?.some(mix => leatherTypes.includes(mix?.type))
    )
    setIsLeatherType(containsLeather)
  }, [fabricData, leatherTypes])

  // Cards oluşturma işlemini ayrı useEffect'e taşıyalım
  useEffect(() => {
    if (!fabricData.length) {
      setCards([])
      return
    }

    let number = 2
    const countryResult = renderCountryCard(country.translate, number)
    number = countryResult.lastNumber

    const result = renderLabelCards(fabricData, number);
    number = result.lastNumber;
    
    const allCards = [
      ...(countryResult.cards || []),
      ...(result.cards || [])
    ];
    setCards(allCards)
    setCurrentNumber(number)
  }, [fabricData, country.translate, renderCountryCard, renderLabelCards])




  if (!fabricData.length) {
    return { cards: [], lastNumber: currentNumber }
  }

  return { cards, lastNumber: currentNumber }
}